<template>
	<div class="catcheck">
		<cube-page type="catcheck-view" title="提交订单">
			<div slot="content">
				<div class="ddcheck">
					<!-- 数量选择 -->
					<div class="ddpapge ddcheckitem">
						<div class="ddxq">
							<div class="ddname ells2">
								{{goods.goods_name}}
							</div>
							<LeoCalendar v-if="iscalender" @confirm="confirm" :deData="deDataP" :useDate="beg_Date">
							</LeoCalendar>
						</div>
					</div>
				</div>
				<van-form @submit="onSubmit">
					<div class="ddcheck" style="margin-bottom: 60px;">
						<van-collapse v-model="activeNames" class="ddcheckitem">
							<van-collapse-item title="房型" name="1">
								<div class="itembox" v-for="(item,i) in fxlist" :key="i">
									<div class="itemleft">
										{{item.name}}
										<!-- 	<div class="rematk">
										发的反馈给考古发掘看过到付即可观看
									</div> -->
									</div>
									<div class="itemright">
										<van-stepper v-model="item.num" min="0" max="8" @plus="numadd(i)"
											@minus="numre(i)" />
									</div>
								</div>
							</van-collapse-item>
						</van-collapse>
						<div class="ykbox ddcheckitem" v-if="totalnum>0">
							<div class="yktitle" style="padding-top: 0;">
								<div class="title">入住信息</div>
								<div class="rightnum">
									共 {{totalnum}} 间房(每间最多住2人)
								</div>
							</div>
							<div class="yklist">
								<van-field label="联系手机" v-model="tel" type="tel" placeholder="用于接收通知短信"
									:rules="[{ required: true, message: '请填写手机号' }]" clearable />
								<van-field v-for="(item,index) in ykListData" :key="index"
									:right-icon="index==0?'question-o':''" v-model="item.contacts"
									placeholder="每间只填1人,姓名不可重复" clearable @click-right-icon="show=true"
									:rules="[{ required: true, message: '请填写住客姓名' }]">
									<template #label>
										<p>{{'房间'+(index+1)}}</p>
										<p style="font-size: 12px;">住客姓名</p>
									</template>
								</van-field>
							</div>
						</div>

					</div>
					<van-submit-bar :price="totalPrice*100" button-text="提交订单" native-type="submit" :loading="disabled"
						text-align="left" style="box-shadow: 0px -5px 3px #f1f1f1;">
					</van-submit-bar>
				</van-form>
				<cube-view></cube-view>
			</div>
		</cube-page>
		<van-popup class="bottompopup" v-model="show" position="bottom" :style="{ height: '48%' }">
			<div class="toptitle">
				<div class="title">
					<span>住客姓名填写说明</span>
				</div>
				<div class="clode" @click="show=false">
					<van-icon name="cross" />
				</div>
			</div>
			<div class="p-conten">
				<p><span class="dian">.</span><span class="nr">住客姓名需要与实际住客证件号上的姓名保持一直</span></p>
				<p><span class="dian">.</span><span class="nr">中文姓名请填写汉字</span></p>
				<p><span class="dian">.</span><span class="nr">英文姓名格式为Surname(姓)/Given name(名)Middle
						name(中间名),姓在前，姓和名之间用"/"隔开,如
						有中间名则空一格紧随之后,如Jenson Green Lewis,填写Jenson/Green Lewis</span></p>
				<p><span class="dian">.</span><span class="nr">预定多个房间时，请填写多个不同的住客姓名</span></p>
			</div>
		</van-popup>

	</div>

</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import CubeView from '@/components/TP/cube-view'
	import LeoCalendar from '@/components/TP/leoCalendarS'
	import leoAddLk from '@/components/TP/leoAddLk1'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage,
			CubeView,
			LeoCalendar,
			leoAddLk
		},
		data() {
			return {
				show: false,
				activeNames: ['1'],
				disabled: false,
				goods_id: this.$route.query.goods_id,
				goods_num: this.$route.query.goods_num * 1,
				goods_sku_id: this.$route.query.goods_sku_id,
				goods: [],
				//日期插件开始
				selectDate: '', //选中的日期
				beg_Date: '', //起始日期
				deDataP: {
					defaultPrice: '',
					Dates: []
				},
				//日期插件结束
				fxlist: [{
					id: 1,
					name: '豪华大床房',
					num: 0
				}, {
					id: 2,
					name: '总统套房',
					num: 0
				}, {
					id: 3,
					name: '舒适双床房',
					num: 0
				}],
				totalnum: 0,
				tel: '',
				ykListData: [],
				iscalender: false,
				isOne: false,
				totalPrice: 0,
			};
		},
		created() {
			this.distributor = this.$store.getters.getDistributor;
			this.axios_Request();
		},
		methods: {
			onSubmit() {
				let that = this;
				if (that.selectDate.length == 0) {
					that.$toast.fail('请选择入住日期');
					return false;
				} 
				if (that.totalPrice == 0) {
					that.$toast.fail('请选择房型');
					return false;
				} 
				if (that.disabled) {
					return false;
				}
				if (that.distributor != null && that.distributor.status != 'normal') {
					Dialog.alert({
						title: '温馨提示',
						message: '请先申请为分销商',
					}).then(() => {
						// 返回首页
						that.$router.push('/My')
						// on close
					});
					return false;
				}
				// use_date 使用时间
				// goods_id 商品ID
				// goods_num 商品数量
				// goods_sku_id
				// visitor 使用人们
				that.disabled = true;
				var url = "/addons/litestore/api.order/submit"
				var param = {
					type: 'gzh',
					use_date: that.selectDate,
					goods_id: that.$route.query.goods_id,
					goods_num: that.goods_num,
					goods_sku_id: that.$route.query.goods_sku_id,
					visitor: that.visitorList
				}
				util.post(url, param,
					function(result) {
						that.disabled = false;
						//return false;
						if (result.code == 1008) {
							//这里不直接跳转了，提示框  为绑定微信，跳转到my页面 绑定微信
							that.$dialog.confirm({
								title: '未通过微信登录',
								message: '您的账号未绑定微信号，请跳转后绑定微信号再进入未支付订单继续支付。'
							}).then(() => {
								that.$router.push({
									path: '/My'
								})
							}).catch(() => {
								that.$router.push({
									name: 'OrderMy',
									params: {
										showType: '0'
									}
								})
							});
						} else {
							// return false;
							//这里发起支付
							console.log('这里能够符合支付条件');
							that.wx_pay_fun(result.data);
						}
					},
					function(result) {
						console.log(result);
					},
					function() {
						that.disabled = false;
					},
				);

			},

			numadd(i) {
				let that = this
				setTimeout(() => {
					that.addYk(true)
				}, 100)
			},
			numre(i) {
				let that = this
				setTimeout(() => {
					that.addYk(false)
				}, 100)
			},
			onJsPrice() {
				let that = this;
				let sdate = that.selectDate;
				let skf = that.fxlist;
				let totalprice = 0;
				sdate.forEach((date) => {
					skf.forEach((kf) => {
						if (kf.num > 0) {
							totalprice += (date.price * 1) * (kf.num * 1);
						}
					});
				});
				that.totalPrice = totalprice
			},
			addYk(isadd) {
				let that = this
				that.totalnum = 0;
				that.fxlist.forEach((item) => {
					that.totalnum += item.num
				})
				if (isadd) {
					let item = {
						contacts: ''
					}
					that.ykListData.unshift(item)
				} else {
					that.ykListData.splice(0, 1)
				}
				that.onJsPrice()
			},
			axios_Request() {
				var url = "/addons/litestore/api.order/confirm"
				let that = this;
				let param = {
					goods_id: that.goods_id,
					goods_num: that.goods_num,
					goods_sku_id: that.goods_sku_id,
					use_date: that.use_date
				}
				//这里直接调用网络接口
				util.get(url, param,
					function(result) {
						if (result.data.error_msg) {
							that.$toast.fail(result.data.error_msg);
							return
						}
						if (result.data.player_rule != '10') {
							//只需要填写一个证件号
							that.isOne = true
						}
						that.goods = result.data.goods
						that.goods_sku = result.data.goods.goods_sku
						that.deDataP.defaultPrice = result.data.goods.goods_price
						that.deDataP.Dates = result.data.calendar_price
						that.beg_Date = result.data.advance_time
						that.iscalender = true
						//提示下架的商品
						if (result.data.error_msg) {
							that.$toast.fail(result.data.error_msg);
						}
					},
				);
			},

			// 当日期改变时
			confirm(item) {
				console.log('日历改变时', item)
				this.selectDate = item
			}
		},
		watch: {
			"$store.state.distributor"() {
				this.distributor = this.$store.getters.getDistributor;
			},
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style lang="less">
	.popup-box {
		padding: 15px;
	}

	.itembox {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 5px 0;
		color: #000;

		.itemleft {
			flex: 1;

			.rematk {
				padding: 2px 0;
				font-size: 12px;
				color: #868686;
			}
		}

		.itemright {
			width: 100px;
		}
	}

	.itembox+.itembox {
		margin-top: 5px;
		// border-top: 1px solid #e5e5e5;
	}

	.popup-box .titile {
		padding: 5px 0;
		display: flex;
		justify-content: space-between;
	}

	.popup-box .titile span {
		display: block;
		font-size: 18px;
		font-weight: 600;
	}

	.popup-box .titile .an {
		color: #00aaff;
		font-size: 15px;
	}

	.popup-box .items {
		padding: 15px 0;
	}

	.popup-box .items .item {
		display: flex;
		padding: 12px 0;
		font-size: 14px;
	}

	.popup-box .items .item span {
		font-size: 12px;
		color: #959595;
	}

	.popup-box .items .item+.item {
		border-top: 1px solid #dedede;
	}

	.popup-box .items .item .left-title {
		width: 80px;
	}

	.ddcheck {
		width: 96%;
		margin: 0 auto;
		// margin-bottom: 65px;
	}

	.ddcheckitem {
		margin-top: 15px;
		border-radius: 15px;
		overflow: hidden;
		background-color: #FFFFFF;
	}

	.catcheck {
		height: 100%;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: 18;
	}

	.catcheck .cube-page>.wrapper .content {
		margin: 0;
	}

	.catindex .catcheck .card-root-c {
		padding-top: 0px;
		position: relative;
	}

	.catcheck .cube-page>.wrapper {
		background-color: #edeff4;
	}

	.ddname {
		margin: 15px;
		padding-top: 10px;
		font-weight: 600;
	}

	.rqbox {
		padding: 15px;
		/* background-color: #fff8f9; */
	}

	.rqbox .title {
		padding-bottom: 15px;
	}

	.rqbox .title .titlename {
		font-weight: 600;
	}

	.rqbox .title .titletips {
		padding-left: 10px;
		font-size: 13px;
		color: #ff0000;
	}

	.rqbox .title .titletips .van-icon {
		padding-right: 5px;
	}

	.ddxznum .ddnum {
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.ddxznum .ddnum .leftnum {
		font-size: 16px;
		font-weight: 600;
	}

	.ddxznum .numtip {
		margin: 10px 0;
		padding: 5px;
		border-radius: 2px;
		background-color: #f2f3f5;
		font-size: 13px;
		color: #959595;
	}

	.ykbox {
		padding: 15px;
	}

	.ykbox .yktitle {
		padding: 15px 15px;
		display: flex;
		align-items: center;
	}

	.ykbox .yktitle .title {
		font-size: 16px;
		font-weight: 600;
	}

	.ykbox .yktitle .rematk {
		margin-left: 15px;
		font-size: 12px;
	}

	.ykbox .yktitle .rematk span:first-child {
		color: #ff0000;
	}

	.ykbox .yklist {}

	.ykbox .yklist .ykitem {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding: 10px 0;
	}

	.ykbox .yklist .ykitem+.ykitem {
		border-top: 1px solid #dedede;
	}

	.ykbox .yklist .ykitem .left {
		display: flex;
		align-items: center;
	}

	.ykbox .yklist .ykitem .left .cleryk {
		text-align: center;
		color: #909090;
	}

	.ykbox .yklist .ykitem .left .cleryk span {
		margin-bottom: 5px;
		display: block;
	}

	.ykbox .yklist .ykitem .left .ykxx {
		padding: 0 15px;
	}

	.ykbox .yklist .ykitem .left .ykxx span {
		color: #00aaff;
	}

	.ykbox .yklist .ykitem .left .ykxx .xxitem {
		padding: 2px 0;
	}

	.right {
		font-size: 13px;
		color: #00aaff;
	}
</style>
